'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

require('slick-carousel/slick/slick.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PrevButton(props) {
  return _react2.default.createElement(
    'a',
    { href: true, className: 'photo-previous', onClick: props.onClick },
    _react2.default.createElement('span', { className: 'icon-prev' }),
    _react2.default.createElement(
      'span',
      { className: 'for-reader' },
      props.i18n.gallery.previousPhoto
    )
  );
} // Gallery

PrevButton.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  onClick: _react.PropTypes.func
};

function NextButton(props) {
  return _react2.default.createElement(
    'a',
    { href: true, className: 'photo-next', onClick: props.onClick },
    _react2.default.createElement('span', { className: 'icon-next' }),
    _react2.default.createElement(
      'span',
      { className: 'for-reader' },
      props.i18n.gallery.nextPhoto
    )
  );
}

NextButton.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  onClick: _react.PropTypes.func
};

var Gallery = function (_Component) {
  (0, _inherits3.default)(Gallery, _Component);

  function Gallery(props) {
    (0, _classCallCheck3.default)(this, Gallery);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Gallery.__proto__ || (0, _getPrototypeOf2.default)(Gallery)).call(this, props));

    _this.state = {
      sliderPadding: 371,
      slideWidth: 539
    };

    _this.updateDimensions = _this.updateDimensions.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Gallery, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.isMobile) {
        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.props.isMobile) {
        window.removeEventListener('resize', this.updateDimensions);
      }
    }
  }, {
    key: 'updateDimensions',
    value: function updateDimensions() {
      // XXX: a workaround for react-slick, should use variableWidth when it is supported
      //      https://github.com/akiran/react-slick#example\
      var sliderWidth = document.querySelector('.fluid-photos-videos').clientWidth;
      var padding = sliderWidth < 1280 ? Math.ceil((sliderWidth - this.state.slideWidth) / 2) : 371;
      this.setState({ sliderPadding: padding });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          i18n = _props.i18n,
          media = _props.media,
          isMobile = _props.isMobile,
          _onClick = _props.onClick;
      var sliderPadding = this.state.sliderPadding;

      var settings = isMobile ? {
        centerMode: true,
        centerPadding: '0px',
        infinite: true,
        arrows: media && media.length > 1,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        // TODO: uncomment this when it is supported
        // variableWidth: true,
        prevArrow: _react2.default.createElement(PrevButton, { i18n: i18n }),
        nextArrow: _react2.default.createElement(NextButton, { i18n: i18n })
      } : {
        centerMode: true,
        centerPadding: sliderPadding + 'px',
        infinite: media && media.length > 1,
        arrows: media && media.length > 1,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        // TODO: uncomment this when it is supported
        // variableWidth: true,
        prevArrow: _react2.default.createElement(PrevButton, { i18n: i18n }),
        nextArrow: _react2.default.createElement(NextButton, { i18n: i18n })
      };

      return _react2.default.createElement(
        _reactSlick2.default,
        settings,
        media.map(function (item, index) {
          return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            _react2.default.createElement(
              'div',
              {
                key: index
                // XXX: comment out 'photos' because it sets position: 'absolute'
                // className="photos"
                , style: {
                  height: '425px',
                  padding: isMobile ? '0' : '0 3px',
                  width: '539px'
                },
                onClick: function onClick(e) {
                  return _onClick(e, index);
                }
              },
              _react2.default.createElement('div', {
                style: {
                  width: '100%',
                  height: '100%',
                  backgroundImage: 'url(' + item.mediaUrl + ')',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }
              })
            )
          );
        })
      );
    }
  }]);
  return Gallery;
}(_react.Component);

Gallery.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  media: _react.PropTypes.array.isRequired,
  isMobile: _react.PropTypes.bool,
  onClick: _react.PropTypes.func
};

exports.default = Gallery;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Gallery.js
// module id = 1203
// module chunks = 0